<section class="content-block-product-catalog">
  <div class="container">
    <h1 class="sr-only">Producten</h1>
    <div (fstrInViewport)="loadProducts()" [once]="true">
      @if (products$ | async; as products) {
        <ul class="row">
          @for (product of products; track product.id) {
            <li class="mb-5 col-6 col-md-4">
              <app-product-card
                [sizes]="{ xs: 6, md: 2, lg: 1 }"
                [collectionHandle]="block.featuredCollectionHandle"
                [product]="product"
              ></app-product-card>
            </li>
          }
          @if (!products.length && (loading$ | async)) {
            <li class="mb-5 col-12 my-2 text-center">
              <p>{{ 'product-overzicht-loading' | fromDictionary }}</p>
            </li>
          }
        </ul>
      }
    </div>

    @if ((page$ | async)?.hasNextPage) {
      <div class="text-center mt-5">
        <button class="button button-outline button--secondary" (click)="loadMore()" [disabled]="(loading$ | async) === true">
          @if ((loading$ | async) === true) {
            <span class="icon-loader css-icon" title="loading..."></span>
          }
          <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
        </button>
      </div>
    }
  </div>
</section>
